<template>
  <el-dialog
    title="离职审核"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="500px"
  >
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="员工姓名">
        <span>{{ employeeName }}</span>
      </el-form-item>
      <el-form-item label="身份证号">
        <span>{{ idCard }}</span>
      </el-form-item>


      <el-form-item label="部门岗位">
        <div v-for="item in employee" :key="item.id" v-if="item.resign_aduit==1">{{ item.department.name }} - {{ item.position.name }}</div>
      </el-form-item>
    
      <el-form-item label="审核状态" prop="audit_status">
        <el-radio-group v-model="form.audit_status">
          <el-radio label="1">通过</el-radio>
          <el-radio label="2">拒绝</el-radio>
        </el-radio-group>
      </el-form-item>
    
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible" size="small">取消</el-button>
      <el-button type="primary" @click="onSubmit" size="small" :loading="loading">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import AfuncApi from '@/api/afunc.js';

export default {
  props: ["open_add", "ma_yg_id", "employeeName", "idCard", "employee"],
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        resign_reason: '',
        audit_status: '',
        audit_remark: ''
      },
      rules: {
        audit_status: [{ required: true, message: '请选择审核状态', trigger: 'change' }],
      }
    };
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  methods: {
    dialogFormVisible() {
      this.$emit("close", {});
    },
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          let employeeId = '';
          if (self.employee && self.employee.length > 0) {
            const resignEmployee = self.employee.find(item => item.resign_aduit == 1);
            if (resignEmployee) {
              employeeId = resignEmployee.id;
            }
          }
          AfuncApi.call({
            model: 'ma_yg',
            action: 'auditResign',
            ma_yg_id: self.ma_yg_id,
            id: employeeId,
            ...self.form
          })
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_yg/index/part/ResignAudit.vue